// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.0.2 (commit bc4fcec6f33f607fb46f61ae66c479eecf5a6e74).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import JoinLobbyReducer from "./join_lobby_reducer";
import LeaveLobbyReducer from "./leave_lobby_reducer";
import SetLoadoutReducer from "./set_loadout_reducer";
import SubmitInputReducer from "./submit_input_reducer";
import DeployMineReducer from "./deploy_mine_reducer";
import DebugPelletBoostReducer from "./debug_pellet_boost_reducer";
import DebugToggleInvincibilityReducer from "./debug_toggle_invincibility_reducer";
import DebugInstantDeathReducer from "./debug_instant_death_reducer";
import DebugInstantVictoryReducer from "./debug_instant_victory_reducer";
import PartyCreateReducer from "./party_create_reducer";
import PartyJoinCodeReducer from "./party_join_code_reducer";
import PartyToggleReadyReducer from "./party_toggle_ready_reducer";
import PartyLeaveReducer from "./party_leave_reducer";
import PartyQueueReducer from "./party_queue_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import AsteroidRow from "./asteroid_table";
import BulletRow from "./bullet_table";
import CtfFlagRow from "./ctf_flag_table";
import GameEventRow from "./game_event_table";
import LobbyRow from "./lobby_table";
import MineRow from "./mine_table";
import MobaBaseRow from "./moba_base_table";
import MobaNpcRow from "./moba_npc_table";
import PartyRow from "./party_table";
import PartyMemberRow from "./party_member_table";
import PelletRow from "./pellet_table";
import PlayerRow from "./player_table";
import PlayerInputRow from "./player_input_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  asteroid: __table({
    name: 'asteroid',
    indexes: [
      { name: 'asteroidId', algorithm: 'btree', columns: [
        'asteroidId',
      ] },
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
    ],
    constraints: [
      { name: 'asteroid_asteroid_id_key', constraint: 'unique', columns: ['asteroidId'] },
    ],
  }, AsteroidRow),
  bullet: __table({
    name: 'bullet',
    indexes: [
      { name: 'bulletId', algorithm: 'btree', columns: [
        'bulletId',
      ] },
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
      { name: 'owner_id_idx', algorithm: 'btree', columns: [
        'ownerId',
      ] },
    ],
    constraints: [
      { name: 'bullet_bullet_id_key', constraint: 'unique', columns: ['bulletId'] },
    ],
  }, BulletRow),
  ctf_flag: __table({
    name: 'ctf_flag',
    indexes: [
      { name: 'carrier_id_idx', algorithm: 'btree', columns: [
        'carrierId',
      ] },
      { name: 'flagId', algorithm: 'btree', columns: [
        'flagId',
      ] },
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
    ],
    constraints: [
      { name: 'ctf_flag_flag_id_key', constraint: 'unique', columns: ['flagId'] },
    ],
  }, CtfFlagRow),
  game_event: __table({
    name: 'game_event',
    indexes: [
      { name: 'eventId', algorithm: 'btree', columns: [
        'eventId',
      ] },
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
    ],
    constraints: [
      { name: 'game_event_event_id_key', constraint: 'unique', columns: ['eventId'] },
    ],
  }, GameEventRow),
  lobby: __table({
    name: 'lobby',
    indexes: [
      { name: 'id', algorithm: 'btree', columns: [
        'id',
      ] },
    ],
    constraints: [
      { name: 'lobby_id_key', constraint: 'unique', columns: ['id'] },
    ],
  }, LobbyRow),
  mine: __table({
    name: 'mine',
    indexes: [
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
      { name: 'mineId', algorithm: 'btree', columns: [
        'mineId',
      ] },
      { name: 'owner_id_idx', algorithm: 'btree', columns: [
        'ownerId',
      ] },
    ],
    constraints: [
      { name: 'mine_mine_id_key', constraint: 'unique', columns: ['mineId'] },
    ],
  }, MineRow),
  moba_base: __table({
    name: 'moba_base',
    indexes: [
      { name: 'baseId', algorithm: 'btree', columns: [
        'baseId',
      ] },
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
    ],
    constraints: [
      { name: 'moba_base_base_id_key', constraint: 'unique', columns: ['baseId'] },
    ],
  }, MobaBaseRow),
  moba_npc: __table({
    name: 'moba_npc',
    indexes: [
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
      { name: 'npcId', algorithm: 'btree', columns: [
        'npcId',
      ] },
    ],
    constraints: [
      { name: 'moba_npc_npc_id_key', constraint: 'unique', columns: ['npcId'] },
    ],
  }, MobaNpcRow),
  party: __table({
    name: 'party',
    indexes: [
      { name: 'join_code_idx', algorithm: 'btree', columns: [
        'joinCode',
      ] },
      { name: 'partyId', algorithm: 'btree', columns: [
        'partyId',
      ] },
    ],
    constraints: [
      { name: 'party_party_id_key', constraint: 'unique', columns: ['partyId'] },
    ],
  }, PartyRow),
  party_member: __table({
    name: 'party_member',
    indexes: [
      { name: 'identity', algorithm: 'btree', columns: [
        'identity',
      ] },
      { name: 'party_id_idx', algorithm: 'btree', columns: [
        'partyId',
      ] },
      { name: 'playerId', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'party_member_identity_key', constraint: 'unique', columns: ['identity'] },
      { name: 'party_member_player_id_key', constraint: 'unique', columns: ['playerId'] },
    ],
  }, PartyMemberRow),
  pellet: __table({
    name: 'pellet',
    indexes: [
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
      { name: 'pelletId', algorithm: 'btree', columns: [
        'pelletId',
      ] },
    ],
    constraints: [
      { name: 'pellet_pellet_id_key', constraint: 'unique', columns: ['pelletId'] },
    ],
  }, PelletRow),
  player: __table({
    name: 'player',
    indexes: [
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
      { name: 'playerId', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'player_player_id_key', constraint: 'unique', columns: ['playerId'] },
    ],
  }, PlayerRow),
  player_input: __table({
    name: 'player_input',
    indexes: [
      { name: 'lobby_id_idx', algorithm: 'btree', columns: [
        'lobbyId',
      ] },
      { name: 'playerId', algorithm: 'btree', columns: [
        'playerId',
      ] },
    ],
    constraints: [
      { name: 'player_input_player_id_key', constraint: 'unique', columns: ['playerId'] },
    ],
  }, PlayerInputRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("join_lobby", JoinLobbyReducer),
  __reducerSchema("leave_lobby", LeaveLobbyReducer),
  __reducerSchema("set_loadout", SetLoadoutReducer),
  __reducerSchema("submit_input", SubmitInputReducer),
  __reducerSchema("deploy_mine", DeployMineReducer),
  __reducerSchema("debug_pellet_boost", DebugPelletBoostReducer),
  __reducerSchema("debug_toggle_invincibility", DebugToggleInvincibilityReducer),
  __reducerSchema("debug_instant_death", DebugInstantDeathReducer),
  __reducerSchema("debug_instant_victory", DebugInstantVictoryReducer),
  __reducerSchema("party_create", PartyCreateReducer),
  __reducerSchema("party_join_code", PartyJoinCodeReducer),
  __reducerSchema("party_toggle_ready", PartyToggleReadyReducer),
  __reducerSchema("party_leave", PartyLeaveReducer),
  __reducerSchema("party_queue", PartyQueueReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.0.2" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

